(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-cards"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function(){
    document.querySelectorAll('.collection-cards-blocks').forEach(elem => {
        new Swiper(elem, {
            slidesPerView: 'auto',
            spaceBetween: -64,
            navigation: {
                nextEl: elem.querySelector('.swiper-button-next'),
                prevEl: elem.querySelector('.swiper-button-prev'),
            }
        })
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq-tabs"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    if(document.querySelectorAll('.tab-button').length > 0){
      const tabs = document.querySelectorAll('.tab-button');
      tabs.forEach(tab => {
            tab.addEventListener('click', function() {
                tabs.forEach(t => {
                    t.classList.remove('active');
                });
                this.classList.add('active');
                const section = document.querySelector(tab.getAttribute('data-href'));
                if (section){
                  let scrollDiv = section.offsetTop - 100;
                  window.scrollTo({ top: scrollDiv, behavior: 'smooth'});
                } 
            });
      });
    } 
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-articles"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function(){
    document.querySelectorAll('.featured_blog_posts_wrap').forEach(elem => {
        new Swiper(elem, {
            slidesPerView: 'auto',
            spaceBetween: 8,
            centeredSlides: true,
            loop: true,
            mousewheel: { forceToAxis: true },
            breakpoints: {
                700: {
                    slidesPerView: 3,
                    spaceBetween: 16,
                    centeredSlides: false,
                    loop: false,
                }
            },
            navigation: {
                nextEl: elem.querySelector('.swiper-button-next'),
                prevEl: elem.querySelector('.swiper-button-prev'),
            }
        })
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-reviews"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function(){
    document.querySelectorAll('.featured_reviews_slider').forEach(elem => {
        new Swiper(elem, {
            slidesPerView: 'auto',
            spaceBetween: 10,
            centeredSlides: true,
            loop: true,
            mousewheel: { forceToAxis: true },
            navigation: {
                nextEl: elem.querySelector('.swiper-button-next'),
                prevEl: elem.querySelector('.swiper-button-prev'),
            }
        })
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function(){
    document.querySelectorAll('.footer__block--menu-title').forEach(element => {
      element.onclick = function(){
        if(window.innerWidth < 750){
          let isOpen = false;
          if(element.parentElement.classList.contains('open')){
            isOpen = true;
          }
          if(document.querySelector('.footer__block--menu.open'))
            document.querySelector('.footer__block--menu.open').classList.remove('open');

          if(isOpen)
            element.parentElement.classList.remove('open');
          else
            element.parentElement.classList.toggle('open');
        }
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-faq"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function(){
    document.querySelectorAll('.faq-question').forEach(function(elem){
        elem.onclick = function(){
            let superParent = elem.closest('.product-faq-section');
            if(superParent.querySelector('.product-faq-block.open')){
                if(superParent.querySelector('.product-faq-block') != elem.parentElement){
                    superParent.querySelector('.product-faq-block.open').classList.remove('open');
                }
            }
            elem.parentElement.classList.toggle('open');
        }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shoppable-video-embeds"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    document.querySelectorAll('.video-list').forEach(function(elem){
        elem.querySelectorAll('.video-card').forEach(function(card){
            card.querySelector('.video-sound-btn').addEventListener('click', function(e) {
                e.preventDefault();
                let videoElement = card.getElementsByTagName('video')[0];
                if(card.classList.contains('muted')){
                    videoElement.muted = true;
                }
                else{
                    videoElement.muted = false;
                }
                card.classList.toggle('muted');
                });
        });

        new Swiper(elem, {
            slidesPerView: 'auto',
            spaceBetween: 16,
            centeredSlides: true,
            loop: true,
            mousewheel: { forceToAxis: true }
        })
    });
  });

  } catch(e) { console.error(e); }
})();
})();
